// components/ActionButtons.jsx
import { Button, Row, Col, Form } from 'antd';
import React from 'react';

const ActionButtons = ({ loading, form }) => {
  return (
    <Row justify="center" gutter={16}>
      <Col>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Grabar
          </Button>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item>
          <Button onClick={() => form.resetFields()}>
            Limpiar
          </Button>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item>
          <Button danger>
            Cancelar
          </Button>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ActionButtons;